import { render, staticRenderFns } from "./UnassignedLogs.vue?vue&type=template&id=65108dfc&scoped=true&"
import script from "./UnassignedLogs.vue?vue&type=script&lang=js&"
export * from "./UnassignedLogs.vue?vue&type=script&lang=js&"
import style0 from "./UnassignedLogs.vue?vue&type=style&index=0&id=65108dfc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65108dfc",
  null
  
)

export default component.exports